import "./Portfolio.scss";
import GreenHeader from "../../Utils/GreenHeader";
import axios from "axios";
import { useLoaderData, Await,defer} from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { Suspense } from "react";
import Loader from "../../Utils/Loader";
import { portfolioPageHelmet } from "../../helmet";

export const portfolioLoader =() => {
  const api = process.env.REACT_APP_API_URL;
    const res = axios.get(`${api}/portfolio`, { withCredentials: true }).then(r => r.data); 
    return defer({ res })
  
};

export default function Portfolio() {
  const title = "OUR PORTFOLIO";
  const details = "We devote all of our experience and efforts for creation";
  const organization = "African Youth Farmers Group";

  const { res } = useLoaderData();

  return (
    <div>
      {portfolioPageHelmet()}
      <GreenHeader title={title} details={details} />
      <Suspense fallback={<Loader height="60vh" />}>
        <Await resolve={res} errorElement={<Loader height="50vh" />}>
          {(items) => {
            return <section className="gallery">
              {items && items.map((item) => (
                <div key={item.id} className="gallery-item">
                  {/* <img src={item.url} alt={item.title} /> */}
                  <LazyLoadImage
                    alt={item.title}
                    src={item.url}
                    height="100%"
                    effect="blur"
                  />
                  {/* Hover overlay with title and organization */}
                  <div className="overlay">
                    <h3>{item.title}</h3>
                    <p>{organization}</p>
                  </div>
                </div>
              ))}
            </section>
          }
          }
        </Await>
      </Suspense>
    </div>
  );
}
